import { mapGetters, mapMutations } from 'vuex';

import {
  GETTERS as APP_GETTERS,
  MUTATES as APP_MUTATES
} from '@/store/modules/app/const';
import {
  GETTERS as PRINT_GETTERS,
  MUTATES as PRINT_MUTATES
} from '@/store/modules/print/const';
import { TOOL_NAME, PER_PAGE_10 } from '@/common/constants';
import ThemesToolPopover from '@/components/ToolPopovers/Theme';
import { getThemesApi, getThemeByIdApi } from '@/api/theme';
import { isEmpty } from '@/common/utils';

export default {
  components: {
    ThemesToolPopover
  },
  data() {
    return {
      selectedThemeId: null,
      optionThemeSelected: {},
      themes: [],
      perPages: PER_PAGE_10,
      currentPageTheme: 1,
      isLoadingTheme: true,
      isLoadingThemeItem: false
    };
  },
  computed: {
    ...mapGetters({
      printThemeSelectedId: PRINT_GETTERS.DEFAULT_THEME_ID,
      selectedToolName: APP_GETTERS.SELECTED_TOOL_NAME
    })
  },
  watch: {
    selectedToolName(toolName) {
      if (!toolName) {
        this.selectedThemeId = null;
        this.optionThemeSelected = {};
      }
      if (this.printThemeSelectedId && toolName === TOOL_NAME.PRINT_THEMES) {
        this.initData();
      }
    }
  },
  methods: {
    ...mapMutations({
      setToolNameSelected: APP_MUTATES.SET_TOOL_NAME_SELECTED,
      triggerThemeIdSelected: PRINT_MUTATES.SET_DEFAULT_THEME_ID
    }),
    /**
     * Set up needly data to render to view: selectedThemeId, optionThemeSelected
     */
    async initData() {
      this.selectedThemeId = this.printThemeSelectedId;
      await this.setOptionThemeSelected(this.printThemeSelectedId);
    },
    /**
     * Set selected theme id after click on theme in list of themes
     */
    onSelectTheme(theme) {
      this.selectedThemeId = theme.id;
      this.setOptionThemeSelected(theme.id);
    },
    /**
     * Set value for select base on theme selected
     */
    async setOptionThemeSelected(themeId) {
      const theme = this.themes.find(item => item.id === themeId);
      if (themeId === this.printThemeSelectedId && !theme) {
        const themeDefault = await getThemeByIdApi(themeId, false);
        this.themes.push(themeDefault);
      }
      this.optionThemeSelected =
        this.themes.find(item => item.id === themeId) || {};
    },
    /**
     * Set selected theme id after change option from select and get theme ref
     */
    onChangeTheme(theme) {
      this.selectedThemeId = theme.id;
    },
    /**
     * Trigger mutation set tool name selected is empty to close popover after click Cancel button
     */
    onCancel() {
      this.setToolNameSelected({
        name: ''
      });
    },
    /**
     * Trigger mutation change theme selected id and set tool name selected is empty to close popover after click Change Theme button
     */
    onChangeThemeSelected() {
      this.triggerThemeIdSelected({
        themeId: this.selectedThemeId
      });
      this.setToolNameSelected({
        name: ''
      });
    },
    async onLoadMoreTheme() {
      if (isEmpty(this.themes)) return;
      if (
        this.currentPageTheme < 0 ||
        (this.currentPageTheme === 1 && this.themes.length > this.perPages + 1)
      ) {
        this.isLoadingThemeItem = false;
        this.isLoadingTheme = false;
        return;
      }
      this.currentPageTheme++;
      const extraThemes = await getThemesApi(
        false,
        this.currentPageTheme,
        true
      );
      if (extraThemes.length < this.perPages) {
        this.isLoadingTheme = false;
        this.isLoadingThemeItem = false;
        this.currentPageTheme = -1;
      }
      extraThemes.forEach(item => {
        const index = this.themes.findIndex(theme => theme.id === item.id);
        if (index < 0) this.themes.push(item);
      });
      this.themes.sort((item1, item2) => item1.id - item2.id);
    }
  },
  async created() {
    if (this.themes.length === 0) {
      const themes = await getThemesApi(false, 1);
      this.themes = themes;
      this.isLoadingThemeItem = true;
    }

    if (this.printThemeSelectedId) {
      this.initData();
    }
  }
};
